export default "__VITE_ASSET__C$aETS5D__"